import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, Redirect } from 'react-router-dom';
import { setLoginState } from '../actions/Login';
import { login, sendOtp, sendEmailOtp } from '../actions/User';
import LoginForm from '../components/Login';
import { ReactComponent as EpikLogoSvg } from '../Res/granite-logo.svg';
import './login.css';
class Authentication extends Component {
  constructor(props) {
    super(props);
    this.state = {
      otpSuccess: true,
    };
  }

  sendEmail = async () => {
    const result = await this.props.sendEmailOtp();
    if (result?.success) {
      this.setState({ otpSuccess: true });
    } else {
      this.setState({ otpSuccess: false });
    }
  };

  sendSmsOtp = async () => {
    const result = await this.props.sendOtp();
    if (result?.success) {
      this.setState({ otpSuccess: true });
    } else {
      this.setState({ otpSuccess: false });
    }
  };

  render() {
    // if (localStorage.getItem('jwtToken') !== null) {
    //   return <Redirect to="/" />;
    // }
    const { username, password } = this.props.UIState;
    const { loginUser, setLoginState } = this.props;

    return (
      <div className="container main-container">
        <div className="login-container">
          <div className="col-12 align-self-start" style={{ display: 'flex' }}>
            <EpikLogoSvg width={120} height={60} />
          </div>
          <div className="col-12 text-left" style={{ marginTop: '30px', minHeight: '50vh' }}>
            <h5>2FA</h5>
            <p style={{ color: '#8998ac' }}>
              Please enter 2 Factor Authentication code to Login to your Epik Dashboard
            </p>
            <LoginForm
              onLogin={loginUser}
              onSendOtp={this.sendSmsOtp}
              onSendEmailOtp={this.sendEmail}
              onLoginDataChange={setLoginState}
              username={username}
              password={password}
              type="2fa"
              otpStatus={this.state.otpSuccess}
            />
          </div>
          <div className="col-12 text-left">
            <Link to="/login" style={{ color: '#3B5BA9' }}>
              Switch Accounts?
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    UIState: {
      username: state.UIState.loginForm.username,
      password: state.UIState.loginForm.password,
    },
    user: state.AppState.user,
  };
};

const mapDispatchToProps = dispatch => ({
  setLoginState: (username, password) => dispatch(setLoginState(username, password)),
  loginUser: (username, password, type, authMode) =>
    dispatch(login(username, password, type, authMode)),
  sendOtp: id => dispatch(sendOtp(id)),
  sendEmailOtp: () => dispatch(sendEmailOtp()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Authentication);
